// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__iVqYG","LayoutContent":"Layout_LayoutContent__iyV5c"};